export default __webpack_public_path__ + "static/img_product_laura-0747bcdbd8bc194301b8a8587f5c1b5d.png";